import React, { useCallback, useEffect, useState } from "react";
import {
  ArtifactType,
  ContentActionType,
  ContentState,
  ContentSubstate,
  getContentAdminActionableItems,
  getContentStatesForAction,
  getContentStatusString,
  ModArtifactType,
  SKArtifact,
  TopicTypeString,
} from "../../models/SKArtifact";
import { Tier, ActionItem } from "../../models/SKArtifact";
import ActionPopup from "../../components/ActionPopup";
import { Link, useNavigate } from "react-router-dom";
import {
  deleteArtifact,
  fetchArtifacts,
  duplicateArtifact,
  updateArtifact,
  updateArtifactStatus,
  getCountsModeratorContent,
  fetchReportedContent,
} from "../../api/artifacts/atrifactService";

import ContainerNavigation from "../../components/ContainerNavigation";
import Loader from "../../components/Loader";
import dayjs from "dayjs";
import { capitalizeFirstLetter, formatAttributeValue, getLanguageName } from "../../utils/stringFunctions";
import { format } from "date-fns";
import ArtifactModerationDialog, { ModerationOption } from "./ArtifactModerationDialog";
import ArtifactStateDialog, { DialoageContent } from "../artifacts/create/container/components/ArtifactStateDialog";
import APILoader from "../../components/APILoader";
import SKPagination, { PaginationObject } from "../../components/SKPagination";
import { useAuth } from "../../context/AuthContext";
import { Pagination } from "../../api/enums";
import TableHeader from "../../components/table/TableHeader";
import { truncate } from "fs";
import { useUpdateList } from "./UpdateListContext";
import { useNavigationBar } from "../../context/NavigationContext";
import { ChannelState } from "../../models/SKChannel";

interface ActionOnItem {
  itemid: string;
  action: ActionItem;
}

// const columns = [
//   { name: "Name", key: "name", span: 2 },
//   { name: "Type", key: "type", span: 1 },
//   { name: "Channel", key: "channel", span: 2 },
//   { name: "Category", key: "cahnnelType", span: 1 },
//   { name: "Submitted", key: "submitted", span: 1 },
//   { name: "Topic", key: "topic", span: 1 },
//   { name: "Age Rating", key: "ageRating", span: 1 },
//   { name: "Tier", key: "tier", span: 1 },
//   { name: "Language", key: "language", span: 1 },
//   { name: "Region", key: "region", span: 1 },
//   { name: "Status", key: "status", span: 1 },
// ];

const actions = [
  {
    label: "Edit",
    onClick: (item: Record<string, any>) => {
      console.log("Edit action for", item);
    },
  },
  {
    label: "Delete",
    onClick: (item: Record<string, any>) => {
      console.log("Delete action for", item);
    },
  },
];

const options = [
  {
    title: "Request for more Information",
    value: "Request for more Information",
  },
  { title: "Not Supported", value: "Not Supported" },
  { title: "Do not meet Guidelines", value: "Do not meet Guidelines" },
  { title: "Multiple Non Approvals", value: "Multiple Non Approvals" },
  { title: "Violent or Gore", value: "Violent or Gore" },
  {
    title: "Hate Speech or Discrimination",
    value: "Hate Speech or Discrimination",
  },
  { title: "Harassment or Bullying", value: "Harassment or Bullying" },
  { title: "Nudity or Sexual Acts", value: "Nudity or Sexual Acts" },
  {
    title: "Misleading or False Information",
    value: "Misleading or False Information",
  },
  { title: "Abusive or Exploitive", value: "Abusive or Exploitive" },
  { title: "Spam", value: "Spam" },
  {
    title: "Obscene or Explicit Language",
    value: "Obscene or Explicit Language",
  },
  { title: "Privacy Violation", value: "Privacy Violation" },
  {
    title: "Copyright Infringement or Illegal",
    value: "Copyright Infringement or Illegal",
  },
  { title: "Other", value: "Other" },
];

type SKArtifactKey = keyof SKArtifact;

interface ArtifactTableHeader {
  key: SKArtifactKey;
  label: string;
  span: number;
  sortable: boolean;
}

const ListArtifactModerator = () => {
  // const [activePopupId, setActivePopupId] = useState<number | null>(null);
  const [artifacts, setArtifacts] = useState<SKArtifact[] | null>([]);
  const [selectedType, setSelectedType] = useState<ModArtifactType>(ModArtifactType.Review);
  const [loading, setLoading] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [actionOnItem, setActionOnItem] = useState<ActionOnItem | null>(null);
  const [dialogContent, setDialogContent] = useState<DialoageContent | null>(null);
  const [paginationObject, setPaginationObject] = useState<PaginationObject | null>(null);
  const [firstDocumentId, setFirstDocumentId] = useState<string | undefined>(undefined);
  const navigate = useNavigate();
  const moderationDialogActions = [ActionItem.reject_edit, ActionItem.reject, ActionItem.delete];
  const [listCount, setListCount] = useState<Record<ModArtifactType, number>>({
    [ModArtifactType.Review]: 0,
    [ModArtifactType.EditReview]: 0,
    [ModArtifactType.Active]: 0,
    [ModArtifactType.Withdrawn]: 0,
    [ModArtifactType.Rejected]: 0,
    [ModArtifactType.Flagged]: 0,
  });

  const { setUpdateContentListFunction } = useUpdateList();
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: "asc" | "desc" } | undefined>(undefined);

  const columns = [
    { name: "Name", key: "title", span: 1 },
    { name: "Type", key: "type", span: 1 },
    { name: "Last Report", key: "lastReportDate", span: 2 },
    { name: "Reports", key: "reportCount", span: 1 },
    { name: "Channel", key: "channel", span: 1 },
    { name: "Language", key: "language", span: 1 },
    { name: "Status", key: "status", span: 1 },
    { name: "Hearts", key: "status", span: 1 },
    { name: "Likes", key: "status", span: 1 },
    { name: "Bookmarks", key: "status", span: 1 },
  ];

  const headers: ArtifactTableHeader[] = [
    // { key: "action", label: "Action", span: 1, sortable: false }, // Non-sortable column
    { key: "title", label: "Title", span: 2, sortable: true },
    { key: "type", label: "Type", span: 1, sortable: false },
    { key: "channelName", label: "Channel", span: 1, sortable: false }, // Non-sortable column
    { key: "topic", label: "Topic", span: 1, sortable: false }, // Non-sortable column
    { key: "age", label: "Age", span: 1, sortable: false }, // Non-sortable column
    { key: "tier", label: "Tier", span: 1, sortable: false }, // Non-sortable column
    { key: "approvedDate", label: "Submitted", span: 1, sortable: false },
    { key: "status", label: "Status", span: 1, sortable: false }, // Non-sortable column
  ];

  const headers1 = [
    // { key: "action", label: "Action", span: 1, sortable: false }, // Non-sortable column
    { key: "title", label: "Title", span: 2, sortable: true },
    { key: "type", label: "Type", span: 2, sortable: false },
    { key: "channel", label: "Channel", span: 1, sortable: false }, // Non-sortable column
    { key: "category", label: "Category", span: 1, sortable: false }, // Non-sortable column
    { key: "createdDate", label: "Submitted", span: 2, sortable: false },
    { key: "topic", label: "Topic", span: 1, sortable: false }, // Non-sortable column
    { key: "age", label: "Age", span: 1, sortable: false }, // Non-sortable column
    { key: "tier", label: "Tier", span: 1, sortable: false }, // Non-sortable column
    { key: "status", label: "Status", span: 1, sortable: false }, // Non-sortable column
  ];

  const headers2: ArtifactTableHeader[] = [
    // { key: "action", label: "Action", span: 1, sortable: false }, // Non-sortable column
    { key: "title", label: "Title", span: 1, sortable: false },
    { key: "type", label: "Type", span: 1, sortable: false },
    { key: "channelName", label: "Channel", span: 1, sortable: false }, // Non-sortable column

    { key: "lastReportedDate", label: "Last Report", span: 1, sortable: false },
    { key: "reportCount", label: "Reports", span: 1, sortable: false },
    { key: "approvedDate", label: "Submitted", span: 1, sortable: false },
    { key: "lastActivityDate", label: "Last Activity", span: 1, sortable: false },
    { key: "language", label: "Language", span: 1, sortable: false },
    { key: "topic", label: "Topic", span: 1, sortable: false }, // Non-sortable column
    // { key: "age", label: "Age", span: 1, sortable: false }, // Non-sortable column
    { key: "status", label: "Status", span: 1, sortable: false }, // Non-sortable column

    { key: "loveCount", label: "Hearts", span: 1, sortable: false },
    { key: "likeCount", label: "Likes", span: 1, sortable: false },
    { key: "bookmarkCount", label: "Bookmarks", span: 1, sortable: false },
    { key: "viewCount", label: "Views", span: 1, sortable: false },
    { key: "shareCount", label: "Shares", span: 1, sortable: false },
  ];

  const { backgroundLocation, showChildRouteAsModal } = useNavigationBar();

  useEffect(() => {
    showChildRouteAsModal(true);

    return () => {
      showChildRouteAsModal(false);
    };
  }, []);

  const fetchData = async (selectedType: ModArtifactType, moveTo: Pagination) => {
    let pageSize = 10;
    try {
      let operator = "==";
      let currentDoc = undefined;
      switch (moveTo) {
        case Pagination.First:
          currentDoc = undefined;
          break;
        case Pagination.Previous:
          currentDoc = paginationObject?.firstDoc;
          break;
        case Pagination.Last:
          currentDoc = paginationObject?.lastDoc;
          switch (selectedType) {
            case ModArtifactType.Active:
              pageSize = listCount.Active % pageSize;
              break;
            case ModArtifactType.Review:
              pageSize = listCount["In Review"] % pageSize;
              break;
            case ModArtifactType.Rejected:
              pageSize = listCount.Rejected % pageSize;
              break;
            case ModArtifactType.Withdrawn:
              pageSize = listCount.Withdrawn % pageSize;
              break;
            case ModArtifactType.EditReview:
              pageSize = listCount["Edit Review"] % pageSize;
              break;
            case ModArtifactType.Flagged:
              pageSize = listCount.Flagged % pageSize;
          }

          break;
        case Pagination.Next:
          currentDoc = paginationObject?.lastDoc;
          break;
      }
      setLoading(true);

      // const { docs, ...rest } = await fetchArtifacts("status", channelId, operator, value, 10, moveTo, currentDoc);

      let pagination: PaginationObject = {
        firstDoc: undefined,
        lastDoc: undefined,
        hasNext: false,
        hasPrev: false,
      };

      switch (selectedType) {
        case ModArtifactType.Review:
          //fetchMyArtifacts("status", channelId, operator, value, 10, moveTo, currentDoc);
          const { docs: reviewedDocs, ...reviewRest } = await fetchArtifacts(
            ["status", "channelStatus"],
            operator,
            [ContentState.IN_REVIEW, ChannelState.ACTIVE],
            pageSize,
            currentDoc,
            undefined,
            moveTo,
            sortConfig
          );
          pagination = reviewRest;
          setArtifacts(reviewedDocs);
          break;
        case ModArtifactType.EditReview:
          const { docs: edidReviewDocs, ...EditReviewRest } = await fetchArtifacts(
            ["status", "subStatus", "channelStatus"],
            operator,
            [ContentState.ACTIVE, ContentSubstate.EDIT_IN_REVIEW, ChannelState.ACTIVE],
            pageSize,
            currentDoc,
            undefined,
            moveTo,
            sortConfig
          );
          pagination = EditReviewRest;
          setArtifacts(edidReviewDocs);
          break;
        case ModArtifactType.Active:
          const { docs: blockedDocs, ...blockedRest } = await fetchArtifacts(
            ["status", "channelStatus"],
            operator,
            [ContentState.ACTIVE, ChannelState.ACTIVE],
            pageSize,
            currentDoc,
            undefined,
            moveTo,
            sortConfig
          );
          pagination = blockedRest;
          setArtifacts(blockedDocs);
          break;
        // case ModArtifactType.Flagged:
        //   const { docs: flaggedDocs, ...flaggedRest } = await fetchArtifacts(
        //     "status",
        //     operator,
        //     State.published,
        //     pageSize,
        //     currentDoc,
        //     true,
        //     moveTo,
        //     sortConfig
        //   );
        //   pagination = flaggedRest;
        //   setArtifacts(flaggedDocs);
        //   break;
        case ModArtifactType.Withdrawn:
          const { docs: withdrawnDocs, ...withdrawnRest } = await fetchArtifacts(
            ["status", "subStatus", "channelStatus"],
            operator,
            [ContentState.DRAFT, ContentSubstate.WITHDRAWN, ChannelState.ACTIVE],
            pageSize,
            currentDoc,
            undefined,
            moveTo,
            sortConfig
          );
          pagination = withdrawnRest;
          setArtifacts(withdrawnDocs);
          break;
        case ModArtifactType.Rejected:
          const { docs: rejectedDocs, ...rejectedRest } = await fetchArtifacts(
            ["status", "subStatus", "channelStatus"],
            operator,
            [ContentState.DRAFT, ContentSubstate.REJECTED, ChannelState.ACTIVE],
            pageSize,
            currentDoc,
            undefined,
            moveTo,
            sortConfig
          );
          pagination = rejectedRest;
          setArtifacts(rejectedDocs);
          break;
        case ModArtifactType.Flagged:
          const { docs: flaggedDocs, ...flaggedRest } = await fetchReportedContent(
            ["status", "channelStatus"],
            [ContentState.ACTIVE, ChannelState.ACTIVE],
            pageSize,
            moveTo,
            currentDoc
          );
          pagination = flaggedRest;
          setArtifacts(flaggedDocs);
          break;
        default:
          break;
      }

      //setArtifacts(docs);
      // let pagination = rest;

      // Handle veryFirstDocument for disabling the "Prev" and "First" buttons

      if (moveTo === Pagination.First || (pagination && pagination.firstDoc && pagination.firstDoc.id === firstDocumentId)) {
        setFirstDocumentId(pagination.firstDoc?.id);
        pagination.hasPrev = false; // Disable previous if we are on the first page
      } else if (moveTo === Pagination.Previous && pagination.firstDoc && pagination.firstDoc.id === firstDocumentId) {
        pagination.hasPrev = false; // Disable previous if we are back on the first page
      }

      setPaginationObject(pagination);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCount = async () => {
    let counts = await getCountsModeratorContent();
    setListCount(counts);
  };

  useEffect(() => {
    fetchCount();
  }, []);

  useEffect(() => {
    setPaginationObject(null);
    setTimeout(() => {
      fetchData(selectedType, Pagination.First);
    }, 0);
  }, [selectedType]);

  // useEffect(() => {
  //   console.log(atrifacts);
  // }, [atrifacts]);

  const getPopItemsForId = (id: string): ActionItem[] => {
    let content = artifacts?.find(element => element.id === id);
    if (content) {
      return getActionableItems(content);
    }
    return [];
  };

  function getActionableItems(content: SKArtifact): ActionItem[] {
    const actions = getContentAdminActionableItems(content.status, content.subStatus);
    // const actions: { [key in State]: ActionItem[] } = {
    //   draft: [],
    //   review: [ActionItem.approve, ActionItem.do_not_approve, ActionItem.block],
    //   published: [ActionItem.unpublish, ActionItem.block],
    //   approved: [ActionItem.unpublish, ActionItem.block],
    //   rejected: [ActionItem.publish, ActionItem.delete],
    //   need_more_info: [],
    //   withdrawal: [],
    //   suspended: [],
    //   blocked: [ActionItem.remove_block, ActionItem.delete],
    // };
    // if (content.flagged) {
    //   let data = [ActionItem.keep_published];
    //   data.push(...actions[content.status]);
    //   return data || [];
    // }
    return actions || [];
  }

  const updateStatus = async (contentId: string, actionItem: ActionItem, reason?: string, note?: string) => {
    const content = artifacts?.find(item => item.id === contentId);
    switch (actionItem) {
      case ActionItem.approve:
        await updateArtifactStatus(contentId, ContentState.ACTIVE, ContentSubstate.NONE, reason, note);
        // await updateArtifact(contentId, { status: content?.autoPublish ? State.published : State.approved });
        updateLocalStatus(contentId, ContentState.ACTIVE, ContentSubstate.NONE);
        break;
      case ActionItem.reject:
        //await updateArtifact(contentId, { status: State.rejected });
        await updateArtifactStatus(contentId, ContentState.DRAFT, ContentSubstate.REJECTED, reason, note);
        updateLocalStatus(contentId, ContentState.DRAFT, ContentSubstate.REJECTED);
        break;
      // case ActionItem.keep_published:
      //   await updateArtifact(contentId, { flagged: false });
      //   removeFlaggedItemLocally(contentId);
      //   // updateLocalStatus(contentId, State.published);
      //   break;
      case ActionItem.reject_edit:
        // await updateArtifact(contentId, { status: State.draft });
        await updateArtifactStatus(contentId, ContentState.ACTIVE, ContentSubstate.EDIT_REJECTED, reason, note);
        updateLocalStatus(contentId, ContentState.ACTIVE, ContentSubstate.EDIT_REJECTED);
        break;
      case ActionItem.approve_edit:
        // await updateArtifact(contentId, { status: State.published });
        await updateArtifactStatus(contentId, ContentState.ACTIVE, ContentSubstate.EDIT_APPROVED, reason, note);
        updateLocalStatus(contentId, ContentState.ACTIVE, ContentSubstate.EDIT_APPROVED);
        break;
    }
  };

  function getDialogeContent(action: ActionItem): DialoageContent | null {
    switch (action) {
      case ActionItem.approve:
        return {
          message: "Are you sure you will like to Approve this Content?",
          description: "Content will be available to the public after publising it.",
          actionTitle: "Approve",
          destructiv: false,
        };
      default:
        return null;
    }
  }

  useEffect(() => {
    if (actionOnItem?.action) {
      const contentDialog = getModerationDialogContent(actionOnItem.action);
      setDialogContent(contentDialog);
    }
  }, [actionOnItem]);

  const updateLocalStatus = (contentId: string, status: ContentState, subStatus: ContentSubstate) => {
    let items = artifacts!.filter(item => {
      if (item.id === contentId) {
        var neItem = item;
        neItem.status = status;
        neItem.subStatus = subStatus;
        return neItem;
      } else {
        return item;
      }
    });

    setArtifacts(items);
  };

  const removeFlaggedItemLocally = (contentId: string) => {
    let items = artifacts!.filter(item => item.id !== contentId);
    setArtifacts(items);
  };

  const editArtifact = async (containerId: string, type: ArtifactType) => {
    console.log("hello");
    navigate("../showArtifact", { state: { containerId, type } });
  };

  const getFormattedValue = (data: SKArtifact, key: SKArtifactKey) => {
    switch (key) {
      case "createdDate":
      case "lastReportedDate":
      case "lastActivityDate":
      case "approvedDate":
        return data[key] ? formatAttributeValue(data[key]) : "—";
      case "status":
        return getContentStatusString(data.status, data.subStatus);
      case "language":
        return data.language ? getLanguageName(data.language) : "—";
      case "topic":
        return data.topic ? TopicTypeString[data.topic] : "";
      case "age":
        return `Age ${data.age}+`;
      case "loveCount":
      case "likeCount":
      case "bookmarkCount":
      case "reportCount":
      case "viewCount":
        return data[key] || 0;
      case "shareCount":
        return data[key] || 0;
      case "coverMedia":
        return "";
      default:
        return data[key];
    }
  };

  function getModerationDialogContent(action: ActionItem): DialoageContent | null {
    switch (action) {
      case ActionItem.delete:
        return {
          message: "Are you sure you will like to Delete this Content?",
          description: "Content will be permanently deleted form the system and you will not be able to recover it.",
          actionTitle: ActionItem.delete,
          destructiv: true,
        };
      case ActionItem.reject:
        return {
          message: "Are you sure you will like to Reject this Content?",
          description: "Content will move back to draft state. User can submit again.",
          actionTitle: ActionItem.reject,
          destructiv: true,
        };
      case ActionItem.reject_edit:
        return {
          message: "Are you sure you will like to Not Approve?",
          description: "Content will move back to draft Edit state. User can submit edits again.",
          actionTitle: ActionItem.reject_edit,
          destructiv: true,
        };
      case ActionItem.approve:
        return {
          message: "Are you sure you will like to Approve this content?",
          description: "Content will be available to the public after approval.",
          actionTitle: ActionItem.approve,
          destructiv: false,
        };
      case ActionItem.approve_edit:
        return {
          message: "Are you sure you will like to Approve this content?",
          description: "Content will be available to the public after approval.",
          actionTitle: ActionItem.approve_edit,
          destructiv: false,
        };
      case ActionItem.keep_published:
        return {
          message: "Are you sure you will like to keep Publishing this content?",
          description: "Content will continue to be available to the public.",
          actionTitle: ActionItem.keep_published,
          destructiv: false,
        };
      default:
        return null;
    }
  }

  const updateContentList = useCallback(
    (contentId: string, newState: ContentState, newSubstate: ContentSubstate) => {
      // Find the content that matches the contentId

      const item = artifacts?.find(content => content.id === contentId);

      if (item) {
        // Use the ActionItem to determine the new state and substate
        const oldState = item.status;
        const oldSubstate = item.subStatus;

        // Helper function to map state/substate to ChannelActionType
        const getActionTypeForState = (state: ContentState, substate: ContentSubstate): ContentActionType | null => {
          if (state === ContentState.IN_REVIEW) return ContentActionType.review;
          if (state === ContentState.ACTIVE) {
            if (substate === ContentSubstate.EDIT_IN_REVIEW) return ContentActionType.edit_review;
            return ContentActionType.active;
          }
          if (state === ContentState.DRAFT) {
            if (substate === ContentSubstate.REJECTED) return ContentActionType.rejected;
            if (substate === ContentSubstate.WITHDRAWN) return ContentActionType.withdrawn;
          }
          return null;
        };

        // Identify previous and new action types
        const previousType = getActionTypeForState(oldState, oldSubstate);
        const newType = getActionTypeForState(newState, newSubstate);

        // Update list count based on the action
        setListCount(prev => {
          const updatedCounts = { ...prev };

          // Decrement the count for the old action type
          if (previousType && updatedCounts[previousType] > 0) {
            updatedCounts[previousType] -= 1;
          }

          // Increment the count for the new action type
          if (newType) {
            if (oldState === ContentState.ACTIVE && newState === ContentState.ACTIVE) {
              // its edit update
              if (!(newSubstate === ContentSubstate.EDIT_APPROVED || newSubstate === ContentSubstate.EDIT_REJECTED)) {
                updatedCounts[newType] = (updatedCounts[newType] || 0) + 1;
              }
            } else {
              updatedCounts[newType] = (updatedCounts[newType] || 0) + 1;
              if (newSubstate === ContentSubstate.REJECTED || newSubstate === ContentSubstate.WITHDRAWN) {
                if (item.loveCount && item.loveCount > 0) {
                  updatedCounts[ModArtifactType.Flagged] = updatedCounts[ModArtifactType.Flagged] - 1;
                }
              }
            }
          }

          return updatedCounts;
        });

        // Update the artifacts state
        setArtifacts(prev => {
          if (!prev) return null;

          return prev.map(content => (content.id === contentId ? { ...content, state: newState, substate: newSubstate } : content));
        });
      }

      // Optionally refresh the data for the selected type
      fetchData(selectedType, Pagination.First);
    },
    [artifacts, selectedType, setArtifacts, setListCount]
  );

  useEffect(() => {
    setUpdateContentListFunction(() => updateContentList);
  }, [updateContentList, setUpdateContentListFunction]);

  useEffect(() => {
    fetchData(selectedType, Pagination.First);
  }, [sortConfig]);

  const handleSortChange = (config: { key: string; direction: "asc" | "desc" } | undefined) => {
    console.log("Sort Config:", config);
    setSortConfig(config);
  };

  const totalSpan = headers2.reduce((sum, item) => sum + item.span, 0);
  const gridColsClass = `grid-cols-${totalSpan}`; //`grid-cols-[repeat(${totalSpan},_1fr)_auto]`;

  return (
    <div className="flex-1 bg-white">
      <div className="flex flex-col flex-1">
        {actionOnItem?.action && dialogContent ? (
          moderationDialogActions.includes(actionOnItem.action) ? (
            <ArtifactModerationDialog
              contentId={actionOnItem.itemid}
              action={actionOnItem.action}
              onAction={(contendId, action, reason, note) => {
                updateStatus(contendId, action as ActionItem, reason, note);
                setActionOnItem(null);
              }}
              onCancel={() => setActionOnItem(null)}
              options={options}
              dialogContent={dialogContent}
            />
          ) : (
            <ArtifactStateDialog
              action={actionOnItem?.action}
              onClose={() => setActionOnItem(null)}
              onUpdate={async () => {
                const action = actionOnItem?.action;
                const contentId = actionOnItem?.itemid;
                await updateStatus(contentId, action);
                setActionOnItem(null);
              }}
              dialogeContent={dialogContent}
            />
          )
        ) : (
          <></>
        )}

        <ContainerNavigation
          backArrow={false}
          title={"Content Inbox"}
          buttonTitle={"Create"}
          subtitle={"All Content"}
          enableLink={true}
          onSearch={() => {}}
        />
        {/* absolute left-0 flex flex-col w-full h-screen p-2 overflow-y-auto top-[84px] */}
        <div className="flex flex-row flex-1 gap-[25px] px-2 mt-[30px] overflow-x-auto">
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setSelectedType(ModArtifactType.Review);
            }}
            className={
              (selectedType === ModArtifactType.Review ? " border-black " : " border-white ") +
              "border-b-2 text-lg  font-bold flex items-center dark:text-black text-nowrap"
            }
          >
            In Review . {listCount["In Review"]}
          </Link>
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setSelectedType(ModArtifactType.EditReview);
            }}
            className={
              (selectedType === ModArtifactType.EditReview ? " border-black " : " border-white ") +
              "border-b-2 text-lg  font-bold flex items-center dark:text-black text-nowrap"
            }
          >
            Edit Review . {listCount["Edit Review"]}
          </Link>
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setSelectedType(ModArtifactType.Active);
            }}
            className={
              (selectedType === ModArtifactType.Active ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold flex items-center mx-2 dark:text-black text-nowrap"
            }
          >
            Active . {listCount.Active}
          </Link>
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setSelectedType(ModArtifactType.Withdrawn);
            }}
            className={
              (selectedType === ModArtifactType.Withdrawn ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold flex items-center mx-2 dark:text-black text-nowrap"
            }
          >
            Withdrawn . {listCount.Withdrawn}
          </Link>
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setSelectedType(ModArtifactType.Rejected);
            }}
            className={
              (selectedType === ModArtifactType.Rejected ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold flex items-center mx-2 dark:text-black text-nowrap"
            }
          >
            Rejected . {listCount.Rejected}
          </Link>
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setSelectedType(ModArtifactType.Flagged);
            }}
            className={
              (selectedType === ModArtifactType.Flagged ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold flex items-center mx-2 dark:text-black text-nowrap"
            }
          >
            Reported . {listCount.Flagged}
          </Link>

          {/* <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setSelectedType(ModArtifactType.Blocked);
            }}
            className={
              (selectedType === ModArtifactType.Blocked ? " border-black " : " border-white ") +
              "border-b-2 text-lg flex items-center mx-2 dark:text-black"
            }
          >
            Blocked
          </Link> */}
        </div>

        <div className="flex flex-col p-2  overflow-auto h-[calc(100vh-354px)]">
          {/* <div key="header" className="hidden p-2 bg-white rounded md:block ">
              <div className="grid grid-cols-12 gap-4 w-[1200px] border-b-[1px] border-gray-300 pb-3">
                <div className="col-span-1 text-lg font-bold md:text-xs">Action</div>
                <div className="col-span-1 text-lg font-bold md:text-xs">Name</div>
                <div className="col-span-1 text-lg font-bold md:text-xs">Type</div>
                <div className="col-span-1 text-lg font-bold md:text-xs">Channel</div>
                <div className="col-span-1 text-lg font-bold md:text-xs">Category</div>
                <div className="col-span-1 text-lg font-bold md:text-xs">Submitted</div>
                <div className="col-span-1 text-lg font-bold md:text-xs">Topic</div>
                <div className="col-span-1 text-lg font-bold md:text-xs">Age Rating</div>
                <div className="col-span-1 text-lg font-bold md:text-xs">Tier</div>
                <div className="col-span-1 text-lg font-bold md:text-xs">Language</div>
                <div className="col-span-1 text-lg font-bold md:text-xs">Region</div>
                <div className="col-span-1 text-lg font-bold md:text-xs">Status</div>
              </div>
            </div> */}
          <TableHeader headers={headers2} onSortChange={handleSortChange} className={`w-full md:min-w-[980px] ${gridColsClass}`} />
          {/* <div className="hidden thinseparator md:block"></div> */}
          {artifacts?.map(content => (
            <div
              key={content.id}
              className="pt-2 my-2 group hover:cursor-pointer hover:font-semibold hover:bg-skseparatorgray "
              onClick={() => navigate(`${content.id}`)}
            >
              {/* Table view for browser  */}
              <div className="hidden md:block">
                <div
                  key={content.id}
                  className={`grid md:grid items-center md:min-w-[980px] ${gridColsClass} gap-4 w-full justify-center  border-b-[1px] border-gray-300 pb-3`}
                >
                  {/* <div className="col-span-1 m-2">
                    <ActionPopup
                      getValues={() => getPopItemsForId(content.id)}
                      onSelect={actionItem =>
                        setActionOnItem({
                          itemid: content.id!,
                          action: actionItem as ActionItem,
                        })
                      }
                      align="left"
                    />
                  </div> */}
                  {headers2.map(header => (
                    <div key={header.key} className={`col-span-${header.span} text-sm font-bold capitalize md:text-xs md:font-normal`}>
                      {getFormattedValue(content, header.key)}
                    </div>
                  ))}
                  {/* <div
                    // to={content.id}
                    className="col-span-2 text-sm font-bold capitalize md:text-xs md:font-normal"
                    // onClick={() => editArtifact(content.id!, content.type!)}
                  >
                    {content.title}
                  </div>
                  <div className="col-span-1 text-sm md:text-xs">{capitalizeFirstLetter(content.type ?? "")}</div>
                  <div className="col-span-1 text-sm md:text-xs">{content.channelName ?? "Channel"}</div>
                  <div className="col-span-1 text-sm md:text-xs">{"Category"}</div>
                  <div className="col-span-1 text-sm md:text-xs">
                    {content.createdDate ? format(content.createdDate.toDate(), "MMM, dd yyyy") : "--"}
                  </div>
                  <div className="col-span-1 text-sm capitalize md:text-xs">{content.topic ? TopicTypeString[content.topic] : ""}</div>
                  <div className="col-span-1 text-sm md:text-xs">Age {content.age}+</div>
                  <div className="col-span-1 text-sm capitalize md:text-xs">{content.tier}</div>
                  <div className="col-span-1 text-sm md:text-xs">English</div>
                  <div className="col-span-1 text-sm md:text-xs">{"United States"}</div>
                  <div className="col-span-1 text-sm capitalize md:text-xs">{`${getContentStatusString(content.status, content.subStatus)}  ${
                    content.reportCount ? `(${content.reportCount})` : ""
                  }`}</div> */}
                </div>
              </div>
              {/* Card view for mobile  */}
              <div className="block md:hidden">
                <div className="relative flex flex-col p-4 mb-4 bg-white rounded-xl border-[1px] border-skseparatorgray">
                  <div className="flex flex-row items-center justify-between">
                    <div className="flex flex-col">
                      <p className="text-gray-500">Name</p>
                      <p className="text-base capitalize hover:cursor-pointer" onClick={() => editArtifact(content.id!, content.type!)}>
                        {content.title}
                      </p>
                    </div>
                    <ActionPopup
                      getValues={() => getPopItemsForId(content.id)}
                      onSelect={actionItem =>
                        setActionOnItem({
                          itemid: content.id!,
                          action: actionItem as ActionItem,
                        })
                      }
                    />
                  </div>
                  <div className="flex flex-row mt-2">
                    <div className="flex flex-col flex-1">
                      <div className="text-gray-500">Type</div>
                      <div className="text-sm capitalize">{content.type!}</div>
                    </div>

                    <div className="flex flex-col flex-1">
                      <div className="text-gray-500">{content.title}</div>
                      <div className="text-sm">Channel</div>
                    </div>
                  </div>
                  <div className="flex flex-row mt-2 ">
                    <div className="flex flex-col flex-1">
                      <div className="text-gray-500">Submitted</div>
                      <div className="text-sm">{content.createdDate ? format(content.createdDate.toDate(), "MMM, dd yyyy") : "--"}</div>
                    </div>
                    <div className="flex flex-col flex-1">
                      <div className="text-gray-500">Status</div>
                      <div className="text-sm capitalize">{`${getContentStatusString(content.status, content.subStatus)}  ${
                        content.reportCount ? `(${content.reportCount})` : ""
                      }`}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* {loading ? <Loader /> : null} */}
        </div>
        {(paginationObject?.hasNext || paginationObject?.hasPrev) && (
          <div className="items-center content-center mx-auto ">
            <SKPagination
              onFirst={() => {
                fetchData(selectedType, Pagination.First);
              }}
              onLast={() => {
                fetchData(selectedType, Pagination.Last);
              }}
              onNext={() => {
                fetchData(selectedType, Pagination.Next);
              }}
              onPrev={() => {
                fetchData(selectedType, Pagination.Previous);
              }}
              hasNext={paginationObject.hasNext || false}
              hasPrev={paginationObject.hasPrev || false}
            />
          </div>
        )}
      </div>

      <APILoader loading={loading} />
    </div>
  );
};

export default ListArtifactModerator;
